import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dictReverseOrder',
  standalone: true
})
export class DictReverseOrderPipe implements PipeTransform {
  /* eslint-disable @typescript-eslint/no-explicit-any */
  transform(value: any): any {
    if (!value) return value;
    return Object.entries(value).sort((a, b) => b[0].localeCompare(a[0])).map(([key, value]) => ({ key, value }));
  }
}
